var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetHelpCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 18c-2.15 0-4.246-.48-6.287-1.438a19.066 19.066 0 0 1-5.426-3.8 19.067 19.067 0 0 1-3.8-5.425C.48 5.296 0 3.2 0 1.05 0 .75.1.5.3.3.5.1.75 0 1.05 0H5.1a.96.96 0 0 1 .625.225A.88.88 0 0 1 6.05.8l.65 3.5c.033.233.03.446-.013.638a1.023 1.023 0 0 1-.287.512L3.975 7.9c.7 1.2 1.58 2.325 2.637 3.375A18.641 18.641 0 0 0 10.1 14l2.35-2.35a1.4 1.4 0 0 1 .588-.338 1.61 1.61 0 0 1 .712-.062l3.45.7c.233.05.425.163.575.338.15.175.225.379.225.612v4.05c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3ZM3.025 6l1.65-1.65L4.25 2H2.025c.083.683.2 1.358.35 2.025.15.667.367 1.325.65 1.975Zm8.95 8.95c.65.283 1.313.508 1.988.675.675.167 1.354.275 2.037.325v-2.2l-2.35-.475-1.675 1.675Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetHelpCall);
export default __webpack_public_path__ + "static/media/getHelp_call.59f61af0b39df1fc135e6ebc37f036aa.svg";
export { ForwardRef as ReactComponent };